<template>
  <div class="info mg-x">
    <p class="title-info">
      <b class="easy-step-txt">3 Easy steps</b>
    </p>
    <div class="d-flex justify-content-between type-info">
      <div class="item">
        <img src="@/assets/images/icons/ic_car_info.svg" class="img-car-info" />
        <p class="title-item fs-20 mb-0 font-weight-bold"><b>Enter car details</b></p>
        <p class="desc-item">
          Our team will create a profile for your car visible to our reliable
          network of dealers and wholesalers
        </p>
      </div>
      <div class="item">
        <img src="@/assets/images/icons/ic_bid.svg" class="img-bid" />
        <p class="title-item fs-20 mb-0 font-weight-bold">
          <b>Absolute best price without delay</b>
        </p>
        <p class="desc-item">
          We offer you the highest bid from our network of buyers
        </p>
      </div>
      <div class="item">
        <img src="@/assets/images/icons/ic_paid.svg" class="img-paid" />
        <p class="title-item fs-20 mb-0 font-weight-bold">
          <b>Quick cash right at your fingertips</b>
        </p>
        <p class="desc-item">
          Receive the highest bid, have your car picked up, and cash in your
          bank account right away
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Info",
};
</script>

<style lang="scss">
.info {
  background-color: #f0f0f0;
  padding-bottom: 50px;
  margin-bottom: 0px;
  
  @media screen and (min-width: 768px) {
    max-width: 1080px;
    padding-bottom: 0px;
    margin-bottom: 3rem;
  }

  .title-info {
    line-height: 28px;
    margin-top: 30px;
    font-size: 36px;

    @media screen and (min-width: 768px) {
      font-size: 40px;
      line-height: 34px;
      margin-top: 40px;
      margin-bottom: 41px;
    }
    .easy-step-txt {
      color: #00bb65;
    }
  }

  .type-info {
    flex-direction: column;
    @media screen and (min-width: 768px) {
      flex-direction: row;
    }

    .item {
      margin-top: 74px;
      &:first-child {
        margin-top: 44px;
      }
      @media screen and (min-width: 768px) {
        margin-top: 0px;
        width: calc(100% / 3 - 15px);

        &:first-child {
          margin-top: 0px;
        }
      }

      .desc {
        font-size: 16px;

        @media screen and (min-width: 768px) {
          flex-direction: row;
        }
      }
    }

    .title-item {
      line-height: 24px;
      margin-top: 25px;
    }

    .desc-item {
      line-height: 22px;
      margin-top: 10px;
      margin-bottom: 0;
    }

    .img-car-info {
      width: 87.5px;
      height: 100px;
    }

    .img-bid {
      width: 102.5px;
      height: 100px;
    }

    .img-paid {
      width: 87.5px;
      height: 100px;
    }
  }
}
</style>
